import axios from "axios";
import { useState } from "react";
import { Modal } from "react-bootstrap";
function SuggestionForm({ onHide, show, config }) {
  const [postLoading, setPostLoading] = useState(false);
  const [postSucess, setPostSucess] = useState(false);
  const [postError, setPostError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const formDataObj = {};
    formData.forEach((value, key) => {
      formDataObj[key] = value;
    });
    setPostLoading(true);
    try {
      const response = await axios.post("/api/v1/suggestions/", formData, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
        xsrfCookieName: "csrftoken",
        xsrfHeaderName: "X-CSRFToken",
      });
      setPostLoading(false);
      setPostSucess(true);
      setPostError(false);
      e.target.reset();
    } catch (error) {
      setPostLoading(false);
      setPostError(true);
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <div>
        <Modal.Header>
          <Modal.Title className="SuggestionForm-title">
            {config.translations.suggestionFormTitle}
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => {
              onHide();
            }}
          ></button>
        </Modal.Header>

        {!postSucess ? (
          <Modal.Body>
            <form onSubmit={handleSubmit}>
              <label className="form-label fw-bold" htmlFor="title">
                {config.translations.suggestionFormLabelTitle}
              </label>
              <input
                className="form-control"
                name="title"
                defaultValue=""
                type="text"
                id="title"
                required
                placeholder={config.translations.suggestionFormLabelTitlePH}
              />

              <label className="form-label fw-bold" htmlFor="description">
                {config.translations.suggestionFormLabelBody}
              </label>
              <textarea
                style={{ minHeight: "150px" }}
                className="form-control"
                name="description"
                defaultValue=""
                id="description"
                placeholder={config.translations.suggestionFormLabelBodyPH}
                required
              ></textarea>

              {postError && (
                <p className="text-error">
                  {config.translations.suggestionFormError}
                </p>
              )}
              <div className="center mt-4">
                <button
                  className="btn btn-primary center gap-2"
                  type="submit"
                  disabled={postLoading}
                >
                  {postLoading ? (
                    <>
                      <span
                        className="spinner-border text-light spinner-border-sm"
                        aria-hidden="true"
                      ></span>
                      <span role="status">Cargando...</span>
                    </>
                  ) : (
                    <>{config.translations.suggestionFormBtn}</>
                  )}
                </button>
              </div>
            </form>
          </Modal.Body>
        ) : (
          <Modal.Body>
            <div className="center flex-column gap-4">
              <i
                className="fa-solid fa-circle-check text-success"
                style={{ fontSize: "4rem" }}
              ></i>
              <h4 className="fs-4 center">
                {config.translations.suggestionFormSucess}
              </h4>
              <button
                className="btn btn-primary"
                type="button"
                onClick={onHide}
              >
                {config.translations.suggestionFormSucessBtn}
              </button>
            </div>
          </Modal.Body>
        )}
      </div>
    </Modal>
  );
}

export default SuggestionForm;
